import React, { useEffect, useState } from "react";
import { testimonialsData } from "../config/Constant";

const Testimonials = ({ testimonials = testimonialsData }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 12000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const testimonialsToShow = testimonials.slice(
    currentIndex,
    currentIndex + 1
  );

  return (
    <section className="relative">
      <div
        className="bg-cover bg-center md:h-fit flex items-center justify-center overflow-hidden"
        style={{ backgroundImage: "url(/image/testinomialBg.webp)" }}
      >
        <div className="flex flex-col items-center py-6 px-3 w-full max-w-6xl">
          <h1 className="text-white text-3xl py-8 text-center">Testimonials</h1>
          <div className="relative w-full flex flex-col justify-center">
            <div className="flex justify-center gap-6 sx:h-[515px] md:h-[440px] w-full flex-wrap">
              {testimonialsToShow.map((testimonial, index) => (
                <div
                  key={index}
                  className="text-white md:tracking-wide flex flex-col w-full max-w-lg px-4"
                >
                  <p className="text-justify break-words hyphens-auto">{`"${testimonial.quote}"`}</p>
                  <h2 className="text-left text-lg mt-4 break-words">
                    {testimonial.name}
                    <br />
                    {testimonial.position}, <br />
                    {testimonial.company}
                  </h2>
                </div>
              ))}
            </div>

            {testimonials.length > 1 && (
              <div className="flex gap-x-10 justify-end md:justify-center mt-6 pr-4 md:pr-0">
                <button
                  onClick={prevTestimonial}
                  className="text-white text-2xl"
                >
                  <i className="fa-solid fa-left-long fa-lg"></i>
                </button>

                <button
                  onClick={nextTestimonial}
                  className="text-white text-2xl"
                >
                  <i className="fa-solid fa-right-long fa-lg"></i>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <hr className="border-gray-400" />
    </section>
  );
};

export default Testimonials;
